// extracted by mini-css-extract-plugin
export default {"createTagModal":"TagModal_createTagModal__8CA5e","header":"TagModal_header__oPlOS","divider":"TagModal_divider__BVcBa"};